import { Route, Redirect, Switch, useHistory } from 'react-router-dom';
import { Suspense, useEffect } from 'react';

// Page Imports
import { LoginPage } from '../containers/login/login';
import SignupPage from '../containers/signup/signup';
import GroupVerificationPage from '../containers/signup/group-verification';
import { VerificationPage } from '../containers/signup/verification';
import AuthenticatePage from '../containers/authenticate/authenticate';
import { ROUTE_PATH } from './route-paths';
import { GroupIdRouter } from './group-id-router';
import useAuth from '../hooks/utils/useAuth';
import TrustedSignup from '../containers/signup/trusted-signup';
import FAQPage from '../containers/landing-page/faq-page';
import { Spinner } from '../components/common/spinner';
import LandingPage from '../containers/landing-page/landing-page';
import PublicViewCollection from '../containers/public-view-collection/public-view-collection';

export const UnauthenticatedRouter = () => {
  // go to login with a redirect url if the user is not authenticated and tries to access a protected route
  const { setRedirectTo } = useAuth();
  const history = useHistory();

  useEffect(() => {
    setRedirectTo(`${history.location.pathname}${history.location.search}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const unauthenticatedRoutes = [
    {
      path: ROUTE_PATH.LOGIN,
      component: LoginPage,
    },
    {
      path: ROUTE_PATH.SIGNUP,
      component: SignupPage,
    },
    {
      path: ROUTE_PATH.SIGNUP_GROUP_VERIFICATION,
      component: GroupVerificationPage,
    },
    {
      path: ROUTE_PATH.SIGNUP_EMAIL_VERIFICATION,
      component: VerificationPage,
    },
    {
      path: ROUTE_PATH.TRUSTED_SIGNUP,
      component: TrustedSignup,
    },
    {
      path: ROUTE_PATH.AUTHENTICATE,
      component: AuthenticatePage,
    },
  ];

  const publicRoutes = [
    {
      path: ROUTE_PATH.LANDING_PAGE,
      component: LandingPage,
    },
    {
      path: ROUTE_PATH.WELCOME_PAGE,
      component: LandingPage,
    },
    {
      path: ROUTE_PATH.FAQS,
      component: FAQPage,
    },
    {
      path: `${ROUTE_PATH.PUBLIC_COLLECTION}/:publicKey`,
      component: PublicViewCollection,
    },
  ];

  return (
    <Suspense fallback={<Spinner />}>
      <Switch>
        {publicRoutes.map(({ path, component: Component }) => (
          <Route exact key={path} path={path} component={Component} />
        ))}
        {unauthenticatedRoutes.map(({ path, component }) => (
          <Route exact key={path} path={path} component={component} />
        ))}
        <Route exact path="/:groupId" component={GroupIdRouter} />
        <Route exact path="/welcome/:groupId" component={GroupIdRouter} />
        <Route exact path="/trusted-signup/:packageCode" component={TrustedSignup} />
        <Route exact path="*" render={() => <Redirect to={ROUTE_PATH.WELCOME_PAGE} />} />
      </Switch>
    </Suspense>
  );
};
